import React from 'react';
import { Button, ButtonSpinner } from '@gluestack-ui/themed';
export const ButtonAsync = ({ pending, isDisabled = false, spinnerProps, children, ...restProps }) => (React.createElement(Button, { opacity: pending ? 0.4 : 1, ...restProps, isDisabled: isDisabled || pending }, pending ? React.createElement(ButtonSpinner, { ...spinnerProps }) : children));
